import logo from '../image/logo.png';

export function LogoGlobalSecView(){
    return (
        <div 
            style={{display:"flex", flexDirection: "column",  padding: "1px"}}
        >
       <img
       alt="Logo"
       width="40px"
      src={logo}
    />
        </div>
    )
}